// Mission Statement Component
export default function MissionStatement() {
  return (
    <section className='py-20 bg-gradient-to-br from-green-50 via-white to-emerald-50 relative overflow-hidden'>
      {/* Background Pattern */}
      <div className='absolute inset-0'>
        {/* Subtle dots pattern */}
        <div className='absolute inset-0'>
          <svg className='w-full h-full opacity-10' viewBox='0 0 100 100'>
            <defs>
              <pattern id='dots' x='0' y='0' width='10' height='10' patternUnits='userSpaceOnUse'>
                <circle cx='2' cy='2' r='0.5' fill='currentColor' className='text-green-400'/>
                <circle cx='7' cy='7' r='0.3' fill='currentColor' className='text-emerald-500'/>
              </pattern>
            </defs>
            <rect width='100%' height='100%' fill='url(#dots)'/>
          </svg>
        </div>
        
        {/* Floating geometric shapes */}
        <div className='absolute top-20 right-1/4 w-16 h-16 border border-green-200/50 rounded-lg rotate-12 animate-pulse'></div>
        <div className='absolute bottom-32 left-1/3 w-12 h-12 border border-emerald-200/40 rounded-full animate-pulse animation-delay-300'></div>
        <div className='absolute top-1/2 right-1/3 w-8 h-8 bg-green-100/60 rounded-sm rotate-45 animate-pulse animation-delay-600'></div>
        
        {/* Subtle wave pattern */}
        <div className='absolute bottom-0 left-0 w-full h-32'>
          <svg className='w-full h-full opacity-20' viewBox='0 0 100 20' preserveAspectRatio='none'>
            <path d='M0,10 Q25,5 50,10 T100,10 L100,20 L0,20 Z' fill='currentColor' className='text-green-200'>
              <animate attributeName='d' dur='15s' repeatCount='indefinite' 
                values='M0,10 Q25,5 50,10 T100,10 L100,20 L0,20 Z;M0,10 Q25,15 50,10 T100,10 L100,20 L0,20 Z;M0,10 Q25,5 50,10 T100,10 L100,20 L0,20 Z'/>
            </path>
          </svg>
        </div>
      </div>
      
      <div className='container mx-auto px-6 relative z-10'>
        <div className='flex items-center gap-12 max-w-7xl mx-auto'>
          {/* Content */}
          <div className='flex-1'>
            <h2 className='text-4xl md:text-5xl font-bold text-gray-900 mb-8 font-comfortaa'>
              Our <span className='text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600'>Mission</span> - Transforming Businesses Through Technology
            </h2>
            <div className='w-24 h-1 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full mb-8'></div>
            <p className='text-xl text-gray-700 leading-relaxed font-light mb-6'>
              We exist to transform challenges into opportunities through the power of technology. Our mission is to serve society by creating 
              <span className='font-semibold text-green-600'> inclusive, sustainable, and practical innovations</span> that address real human needs.
            </p>
            <p className='text-lg text-gray-600 leading-relaxed'>
              Guided by humility and responsibility, we seek to give back at every step becoming a trusted solution provider that communities can rely on for growth and positive change.
            </p>
          </div>
          
          {/* Image */}
          <div className='flex-1 hidden lg:block'>
            <div className='relative'>
              <img 
                src='/assets/tech.webp' 
                alt='Our Mission' 
                className='w-full h-96 object-cover rounded-2xl shadow-2xl'
              />
              <div className='absolute inset-0 bg-gradient-to-tr from-green-600/20 to-emerald-600/20 rounded-2xl'></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}